import script from "./HandSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./HandSelector.vue?vue&type=script&setup=true&lang=js"

import "./HandSelector.vue?vue&type=style&index=0&id=9fb11dec&lang=css"

const __exports__ = script;

export default __exports__